import LayoutCreditCardApplication from 'components/Content/ContentLayout/LayoutCreditCardApplication/LayoutCreditCardApplication';

export default LayoutCreditCardApplication;
